// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f51a66fd","239":"b3b8bc7d","732":"23babdd9"}[chunkId] + ".chunk.js";
};